import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeApiTypes,
  makeQueryParams,
} from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('FETCH_HEALTH_QUESTIONS', 'healthQuestions'),
}

export const fetchHealthQuestions = (
  stateCode,
  subproduct,
  insuranceFilingUuid,
) => ({
  [RSAA]: {
    endpoint: getApiPath(
      `acct`,
      `pub/profile/healthQuestions${makeQueryParams({
        stateCode,
        subproduct,
        insuranceFilingUuid,
      })}`,
    ),
    method: 'GET',
    headers: {
      'x-api-key': process.env.REACT_APP_X_API_KEY,
      token: 'IGNORE',
    },
    types: [
      types.FETCH_HEALTH_QUESTIONS_REQUEST,
      {
        type: types.FETCH_HEALTH_QUESTIONS_SUCCESS,
        meta: { stateCode, insuranceFilingUuid },
      },
      types.FETCH_HEALTH_QUESTIONS_ERROR,
    ],
  },
})

export const initialState = {
  busy: false,
  error: '',
  entities: [], //was ordered map

  // this will be populated with questions broken down into states.
  // Each key for this object will be a state ('CA') and within that
  // will be an Array of questions, just like entities above.
  stateQuestions: {}, // { state: questions[] }
}

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.FETCH_HEALTH_QUESTIONS_REQUEST: {
      return {
        ...state,
        busy: true,
        error: '',
      }
    }
    case types.FETCH_HEALTH_QUESTIONS_SUCCESS: {
      return {
        ...state,
        busy: false,
        entities: payload,
        stateQuestions: {
          ...state.stateQuestions,
          [meta.stateCode]: payload,
        },
      }
    }
    case types.FETCH_HEALTH_QUESTIONS_ERROR: {
      return {
        ...state,
        busy: false,
        error: payload.response.message,
      }
    }

    default:
      return state
  }
}
